import { mapActions } from 'vuex';
import refineHistory from '@/components/account/history/trades/refine-history/refine-history.vue';
import buttonWithInfo from '@/components/account/history/trades/button-with-info/button-with-info.vue';
import { MODALS } from '@/components/app/app-modals/app-modals';

export default {
  props: {
    value: Object,
    markets: Array,
    recent: Boolean,
    isOpen: Boolean,
  },
  components: {
    refineHistory,
    buttonWithInfo,
  },
  computed: {
    openModifier() {
      return {
        'history-filters--open': this.isOpen,
      };
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentSmallPopup']),
    onRecent() {
      this.$emit('input', null);
      const params = (!this.value) ? {} : { marketId: 'all' };
      this.$router.push({ name: 'account-history', params });
    },
    onMarkets() {
      this.$router.push({ name: 'account-history', params: { marketId: 'all' } });
    },
    onInfoClick() {
      this.setCurrentSmallPopup(MODALS.SMALL_TRADE_INFO);
    },
    onRefineHistoryInput(e) {
      this.$emit('input', e);
      this.$router.push({ name: 'account-history', params: { marketId: e.marketId } });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/history/trades/history-filters/history-filters.js